import { makeObservable, observable, action, computed } from 'mobx'
import {
  ProviderTemplate,
  ProviderTemplateFetchParams,
} from '../providers/types'
import Template from './Template'
import BaseProvider from '../providers/BaseProvider'
import Store from './Store'

export default class TemplateCollection {
  items = observable.array<Template>([])
  store: Store
  provider: BaseProvider
  state: 'ready' | 'loading' | 'failed' = 'ready'
  defaultParams: ProviderTemplateFetchParams

  constructor(store: Store, defaultParams?: ProviderTemplateFetchParams) {
    makeObservable(this, {
      items: observable,
      state: observable,
      setState: action,
      fromProvider: action,
      isLoading: computed,
      isReady: computed,
    })
    this.store = store
    this.provider = store.provider
    this.defaultParams = defaultParams || {}
  }

  setState(newState: TemplateCollection['state']) {
    this.state = newState
  }

  get isReady() {
    return this.state === 'ready'
  }

  get isLoading() {
    return this.state === 'loading'
  }

  async fetch(fetchParams?: ProviderTemplateFetchParams) {
    const params = fetchParams || this.defaultParams
    this.setState('loading')
    try {
      const data = await this.provider.fetchTemplates(params)
      this.fromProvider(data)
      this.setState('ready')
    } catch (e) {
      console.error(e)
      this.setState('failed')
    }
  }

  get = (id: string) => {
    return this.items.find((item) => item.id === id)
  }

  deleteTemplate = async (id: string) => {
    const template = this.get(id)
    if (!template) return
    await template.handleDelete()
    this.items.replace(this.items.filter((item) => item.id !== id))
  }

  addTemplate = (payload: { name: string; deadline?: number }) => {
    const template = new Template(this.store, payload.name)
    template.deadline = payload.deadline || 0
    this.items.push(template)
    void template.handleCreate()
    return template
  }

  fromProvider = (data: ProviderTemplate[]) => {
    this.items.replace(
      data.map((item) => {
        const template = new Template(this.store, item.name)
        template.fromJSON(item)
        return template
      })
    )
  }
}
